import { makeStyles } from "@material-ui/core/styles";


const theme = (props) => {
  const styles = makeStyles(theme => ({
    container: {
      padding: 20,
      '& .title': {
        color: '#374151',
        fontWeight: 500,
        fontSize: 20,
        // opacity: 0.8,
        marginBottom: 20,
      },
      '& .text': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 14,
        marginBottom: 20,
        '& span': {
          fontWeight: 300,
        }
      }
    },

    '@media (max-width: 600px)': {
      container: {
        padding: 14,
        '& .title': {
          fontSize: 'var(--mobile-title-size)',
          lineHeight: 'var(--lh-title)',
          marginBottom: 12,
          color: 'var(--text-strong)!important',
        },
        '& .text': {
          fontWeight: 400,
          marginBottom: 6,
          color: 'var(--text-body)',
          fontSize: 'var(--mobile-body-size)',
          lineHeight: 'var(--lh-body)',
        },
      }
    }

  }));
  return styles();
}
export default theme;

